export default "* Ånder\n* Offergave\n* Betydning\n* Værdi";